import { Layout } from '@/views/scheduler';

export default {
    path: '/scheduler',
    component: Layout,
    children: [
        { path: 'crons', component: () => import('@/views/scheduler/Crons.vue') },
    ]
};
